var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconMiner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 44,
    viewBox: "0 0 40 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_miner"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M5 1H34.5678V5.06893H5V1Z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    d: "M6 5H33.0839C35.8453 5 38.0839 7.23858 38.0839 10V37.448C38.0839 40.2094 35.8453 42.448 33.0839 42.448H6.00001C3.23858 42.448 1 40.2094 1 37.448V10C1 7.23858 3.23858 5 6 5Z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 3",
    d: "M35 24.1491C35 32.5244 28.2755 39.2981 20 39.2981C11.7245 39.2981 5 32.5244 5 24.1491C5 15.7737 11.7245 9 20 9C28.2755 9 35 15.7737 35 24.1491Z",
    fill: "none",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Oval 3_2",
    d: "M28 24C28 28.4183 24.4183 32 20 32C15.5817 32 12 28.4183 12 24C12 19.5817 15.5817 16 20 16C24.4183 16 28 19.5817 28 24Z",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 2",
    d: "M2.10938 6.5625L37.0807 42.0493",
    stroke: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    d: "M36.7195 6.66406L2.20312 41.6795",
    stroke: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2061_21350",
    x1: 19.7839,
    y1: 9.10339,
    x2: 22.0342,
    y2: -2.60183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2061_21350",
    x1: 19.5419,
    y1: 63.172,
    x2: 58.9883,
    y2: 24.0898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2061_21350",
    x1: 20,
    y1: 56.4472,
    x2: 52.2967,
    y2: 24.4486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2061_21350",
    x1: 20,
    y1: 40,
    x2: 36,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2061_21350",
    x1: 19.595,
    y1: 59.7927,
    x2: 55.078,
    y2: 24.8251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2061_21350",
    x1: 19.4613,
    y1: 59.1872,
    x2: 54.4731,
    y2: 24.6743,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0522DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828672,
    stopColor: "#C1A8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7B3FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiner);
export default __webpack_public_path__ + "res/media/icon_miner.1fb66a8b4fad6d7739abbbd3e016cd8b.svg";
export { ForwardRef as ReactComponent };